import gettext from '@sdk/lang/gettext';
import { SUBSCRIPTION_BILLING_CYCLES } from '@sdk/account/constants';
import moneyDisplay from '@sdk/common/currency/moneyDisplay';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import Text14 from '@sdk/components/ui/typography/Text14';
import type { CurrencyType } from '@sdk/common/currency/types/CurrencyType';

const getSubscriptionCycleOptions = ({
  yearlyPlanDiscount,
  monthlyPricePerUserPerMonth,
  yearlyPricePerUserPerMonth,
  currency,
}: {
  yearlyPlanDiscount: number;
  monthlyPricePerUserPerMonth: number;
  yearlyPricePerUserPerMonth: number;
  currency: CurrencyType;
}) => {
  if (yearlyPlanDiscount) {
    const monthlyPricePerUnitFormatted = moneyDisplay({
      value: monthlyPricePerUserPerMonth,
      currency,
    });

    const yearlyPricePerUnitFormatted = moneyDisplay({
      value: yearlyPricePerUserPerMonth,
      currency,
    });

    return [
      {
        label: gettext('Monthly - %(monthlyPricePerUnitFormatted)s per user per month', {
          monthlyPricePerUnitFormatted,
        }),
        value: SUBSCRIPTION_BILLING_CYCLES.MONTHLY,
      },
      {
        label: gettext('Annual - %(yearlyPricePerUnitFormatted)s per user per month', {
          yearlyPricePerUnitFormatted,
        }),
        labelComponent: (
          <>
            {gettext('Annual - %(yearlyPricePerUnitFormatted)s per user per month', {
              yearlyPricePerUnitFormatted,
            })}
            &nbsp;(<Text14 themeColor={ThemeColorType.success}>Saving 15%</Text14>)
          </>
        ),
        value: SUBSCRIPTION_BILLING_CYCLES.ANNUAL,
      },
    ];
  }

  return [
    { label: gettext('Monthly'), value: SUBSCRIPTION_BILLING_CYCLES.MONTHLY },
    { label: gettext('Annual'), value: SUBSCRIPTION_BILLING_CYCLES.ANNUAL },
  ];
};

export default getSubscriptionCycleOptions;
